import axiosClient from 'api/axiosClient';
import endpoints from 'api/endpoints';

export const fetchHomePage = () => {
  return axiosClient.get(endpoints.HOME);
};
